/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Button,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { normalizeData } from 'utils/normalizers';
import Table from 'components/Table';
import Select from 'components/Select';
import currencyFormatter from 'utils/currencyFormatter';
import {
  getAreas,
} from 'api/catalogos/index';
import {
  getDescuentosSaldos,
} from 'api/nominas/descuentos/descuentosSaldos';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getEmpleadosConDatosOpFilteredPaginated, getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPuestos } from 'api/catalogos/puestos';
import { getDescuentos } from 'api/nominas/descuentos/descuentos';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { SearchOutlined } from '@ant-design/icons';
import CustomSearch from 'components/customSearch';

export const descuentosSaldosPermission = {
  permissionModel: 'descuentoempleadosaldo',
  catalogsModels: [],
  tabsModels: [],
};

const DescuentoSaldo = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [areas, setAreas] = useState();
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [puestos, setPuestos] = useState();
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [descuentosFiltrados, setDescuentosFiltrados] = useState([]);
  const [descuentosEmpleados, setDescuentosEmpleados] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [empleado, setEmpleado] = useState();
  const [descuento, setDescuento] = useState();
  const [descuentoEmpleado, setDescuentoEmpleado] = useState();
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [openSearch, setVisibleSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();

  const nameEmpleado = 'empleado';
  const namePuesto = 'puesto';
  const nameArea = 'area';
  const namePlaza = 'plaza';

  const getPlaza = (idEmpleado) => {
    const _datoOperacional = datosOperacionales?.find((e) => e.empleado === idEmpleado);
    const idPlaza = _datoOperacional?.plaza;
    return ({
      _plaza: plazas?.find((p) => p.id === idPlaza),
      _datoOp: _datoOperacional,
    });
  };

  let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDescuentosSaldos({
      empleado,
      descuento,
      descuento_empleado: descuentoEmpleado,
    });
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _areas,
        _empleados,
        _plazas,
        _puestos,
        _adminPlazas,
        _descuentos,
        _periodos,
        _periodosNominas,
        _tipos_de_nominas_empleados,
        _datosOperacionales,
      ] = await Promise.all([
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getEmpleadosOptimized(),
        getPlazasvistaOptimized(),
        getPuestos(),
        getAdministracionDePlazasvistaOptimized(),
        getConfiguracionDescuentos({ requiere_control_de_saldo_de_descuentos: true, estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeNominasEmpleados(),
        getDatoOperacionalesDeEmpleados(),
      ]);
      const formattedURS = normalizeData(_areas);
      if (mounted) {
        setAreas(formattedURS);
        setEmpleados(_empleados);
        setPlazas(_plazas);
        setPuestos(_puestos);
        setAdminPlazas(_adminPlazas);
        setDescuentos(_descuentos);
        setPeriodos(_periodos.filter((periodosNomDetalle) => _periodosNominas.some((periodoNomina) => periodoNomina.id === periodosNomDetalle?.periodo_de_nomina)));
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setDatosOperacionales(_datosOperacionales);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (empleado) {
      fetchData();
    }
  }, [descuento, descuentoEmpleado]);

  const onChangeEmpleado = (empleadoId) => {
    if (empleadoId) {
      const { _plaza } = getPlaza(empleadoId);

      form.setFieldsValue({
        [namePuesto]: _plaza?.puesto_descripcion || '',
        [nameArea]: _plaza?.directorio_area_clave_y_nombre || '',
        [namePlaza]: _plaza?.clave_y_descripcion || '',
      });
      setEmpleado(empleadoId);
      form.resetFields(['descuento', 'descuento_empleado']);
      setData([]);
      getDescuentos({ empleado: empleadoId }).then((_descEmp) => {
        const descEmpList = Array.isArray(_descEmp) ? _descEmp : (_descEmp?.results ?? []);
        const idsConImporteBase = new Set(
          descEmpList
            .filter((d) => d.importe_base != null && Number(d.importe_base) > 0)
            .map((d) => d.descuento),
        );
        setDescuentosFiltrados(descuentos.filter((d) => idsConImporteBase.has(d.id)));
      });
    }
  };

  const onChangeDescuento = (value) => {
    setDescuento(value);
    setDescuentoEmpleado();
    form.resetFields(['descuento_empleado']);
    getDescuentos({
      empleado,
      descuento: value,
    }).then((_data) => {
      setDescuentosEmpleados(Array.isArray(_data) ? _data : (_data?.results ?? []));
    });
  };

  const validateInput = async () => {
    setLoading(true);
    setSelectedEmpleadoSearch();
    form.setFieldsValue({ [namePuesto]: '', [nameArea]: '', [namePlaza]: '' });
    const searchEmp = form.getFieldValue(nameEmpleado);
    if (!searchEmp) {
      setVisibleSearch(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`);
    const result = res?.results[0];
    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    setSelectedEmpleadoSearch(empleadoResult);
    if (empleadoResult) {
      form.setFieldsValue({
        empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
      });
    } else {
      form.resetFields(['empleado']);
    }
    onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURIDatosOpPaginado);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
    setDataSearch(_empleados);
    return setLoading(false);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (empObject) => {
        const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
        const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
        const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
        return `${puestoEmp?.descripcion || ''}`;
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'descuento_empleado',
      key: 'clave_saldo',
      width: 100,
      render: (val) => descuentosEmpleados.find((e) => e.id === val)?.clave,
    },
    {
      titleText: 'No. de Nómina',
      dataIndex: 'numero_de_nomina',
      key: 'numero_de_nomina',
      width: 150,
    },
    {
      titleText: 'Periodo de Nómina',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 250,
      render: (val) => {
        const _periodo = periodos.find((e) => e.id === val);
        if (_periodo) {
          return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} - ${_periodo?.fecha_final})`;
        }
        return '';
      },
    },
    {
      titleText: 'Importe Base',
      dataIndex: 'importe_base',
      key: 'importe_base',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'No. de Descuento',
      dataIndex: 'no_descuento',
      key: 'no_descuento',
      width: 200,
    },
    {
      titleText: 'Importe Descuento',
      dataIndex: 'importe_descuento',
      key: 'importe_descuento',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Saldo',
      dataIndex: 'saldo',
      key: 'saldo',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
        >
          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Form.Item
                        label="No. y Nombre del Empleado"
                        name="empleado"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                      <Button
                        loading={loading}
                        onClick={validateInput}
                        icon={<SearchOutlined />}
                        style={{
                          width: '2.7rem',
                          marginTop: '-2px',
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              {selectedEmpleadoSearch
                ? (
                  form.setFieldsValue({
                    empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
                  })
                ) : null}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={namePuesto}
                  label="Puesto"
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={nameArea}
                  label="Área"
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={namePlaza}
                  label="No. de Plaza"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="descuento"
                  label="Concepto de Descuento"
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="concepto"
                    dataSource={descuentosFiltrados}
                    onChange={onChangeDescuento}
                    render={(value) => `${value?.clave} - ${value?.concepto}`}
                    disabled={!empleado}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="descuento_empleado"
                  label="Clave de Descuento"
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="clave"
                    dataSource={descuentosEmpleados}
                    onChange={(value) => setDescuentoEmpleado(value)}
                    disabled={!descuento}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Table
            cols={columns}
            data={data}
            allowExportPDF={false}
          />
        </Card>
        <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={onChangeEmpleado}
        />
      </Spin>
    </Row>
  );
};

export default DescuentoSaldo;
